import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorBoundaryComponent } from 'src/app/shared/common/error-boundary/error-boundary.component';
import { ErrorResponse } from '../../abstracts/models/error-response.abstract';
import { LoggerService } from './logger.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  private injector: Injector;

  constructor(injector: Injector, private logger: LoggerService) {
    this.injector = injector;
  }

  handleError(error: ErrorResponse): void {
    const errorBoundary = this.injector.get(ErrorBoundaryComponent);
    errorBoundary.handleError(error);
    this.logger.error(error.message);
  }
}
